export const FROM_COMPANY_MAP = {
  Locate: 'LOCATE_CLIENT',
  Shukah: 'SHUKAH_CLIENT',
  Maeda: 'MAEDA_CLIENT',
};
